import { Button, Dialog, Field, TextOutput } from 'Components/Core';
import { WorksheetGrid, WorksheetLabelByTypeInjectedPropsProvider, WorksheetLink } from 'Components/Worksheets/Core';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import WorksheetBatchUpdateSelectionGridInjectedPropsProvider from '../WorksheetBatchUpdateSelectionGrid/WorksheetBatchUpdateSelectionGridInjectedPropsProvider';
import './WorksheetBatchUpdateCheckedWorksheetsDialog.scss';

const CheckedWorksheetGrid: React.FC = () => {
  const typeId = useSelector((state) => state.worksheetBatchUpdate.typeId);
  const worksheetIds = useSelector(
    (state) =>
      Object.entries(state.worksheetBatchUpdate.worksheets)
        .filter(
          ([worksheetId, worksheet]) =>
            //locked, but can be unchecked
            worksheet.status.readonly.locked &&
            worksheet.status.readonly.uncheckAllowed &&
            //and selected for update
            state.worksheetBatchUpdate.worksheetsState[worksheetId].selected
        )
        .map(([worksheetId, _]) => worksheetId),
    shallowEqual
  );

  return (
    <div className="WorksheetBatchUpdateCheckedWorksheetsDialog-Content">
      <p>The following worksheets will be unchecked so that the batch update can be applied:</p>

      <WorksheetGrid
        identifierColumns={[]}
        fieldColumns={[
          {
            component: <Field input={<TextOutput />} name={'header.Sample.SampleId'} />,
            header: 'Sample ID',
            width: 160,
          },
          {
            component: (worksheetId) => (
              <WorksheetLink
                worksheetPath={`worksheetBatchUpdate.worksheets[${worksheetId}]`}
                shortNameOnly
                openInNewTab
              />
            ),
            header: 'Worksheet',
            width: 200,
            hidden: window.qest.isFrame,
          },
          {
            component: <Field input={<TextOutput />} name={'header.CheckedBy.Name'} />,
            header: 'Checked By',
            width: 200,
          },
          {
            component: <Field input={<TextOutput />} name={'header.CheckedDate'} />,
            header: 'Date Checked',
            width: 120,
          },
        ]}
        worksheetIds={worksheetIds}
        HeaderPropsProvider={({ children }) => (
          <WorksheetLabelByTypeInjectedPropsProvider children={children} typeId={typeId!} />
        )}
        WorksheetPropsProvider={WorksheetBatchUpdateSelectionGridInjectedPropsProvider}
      />
    </div>
  );
};

interface IWorksheetBatchUpdateUncheckDialogProps {
  visible: boolean;
  onContinue: (event?: any) => void;
  onClose: (event?: any) => void;
}

const WorksheetBatchUpdateCheckedWorksheetsDialog: React.FC<IWorksheetBatchUpdateUncheckDialogProps> = (
  props: IWorksheetBatchUpdateUncheckDialogProps
) => {
  const closeDialog = (continuePressed: boolean) => {
    if (continuePressed) {
      props.onContinue();
    }
    props.onClose();
  };
  return (
    <Dialog
      visible={props.visible}
      onClose={() => closeDialog(false)}
      title="Checked worksheets"
      buttons={[
        <Button primary key="1" autoFocus onClick={() => closeDialog(true)}>
          Continue
        </Button>,
        <Button key="0" onClick={() => closeDialog(false)}>
          Cancel
        </Button>,
      ]}
    >
      {props.visible ? <CheckedWorksheetGrid /> : undefined}
    </Dialog>
  );
};

export { WorksheetBatchUpdateCheckedWorksheetsDialog };
export default WorksheetBatchUpdateCheckedWorksheetsDialog;
